import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from "react-i18next";
import translation_en from "./translations/en/translation.json";
import translation_sk from "./translations/sk/translation.json";
import translation_da from "./translations/da/translation.json";

const fallbackLng = 'en';
const availableLanguages = ['en', 'sk', 'da'];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        returnNull: false,
        fallbackLng: fallbackLng,
        // debug: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
        resources: {
            en: {
                translation: translation_en
            },
            sk: {
                translation: translation_sk
            },
            da: {
                translation: translation_da
            },
        },
        // lng: "en", //Do not use because of detector
        supportedLngs: availableLanguages,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

// "{{amount, currency}}" in translations — shops are EUR unless the call site
// passes {currency: shop.currency}. Whole euros render without decimals (€18).
i18n.services.formatter?.add('currency', (value, lng, options) => {
    const amount = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(amount)) return String(value ?? '')
    const currency = (options as {currency?: string} | undefined)?.currency ?? 'EUR'
    try {
        return new Intl.NumberFormat(lng, {
            style: 'currency',
            currency,
            minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
            maximumFractionDigits: 2,
        }).format(amount)
    } catch {
        return `${amount} ${currency}`
    }
})

export default i18n;
